<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 10:58:53
 * @LastEditTime: 2020-06-15 14:31:18
 * @Description: 单场考试信息
 -->
<template>
  <div class="paper-info">
    <table>
      <tbody>
        <tr>
          <td class="category">考试名称：
            <span>{{ paperInfo.name }}</span>
          </td>
          <td class="category">
            <pss-button text="导出" @on-click="exportBtnClickHandler" />
          </td>
          <td></td>
        </tr>
        <tr>
          <td class="category">参考人数：
            <span>{{ paperInfo.examinerNumber }}</span>
          </td>
          <td class="category">缺考人数：
            <span>{{ paperInfo.absenteesNumber }}</span>
          </td>
          <td class="category">未通过人数：
            <span>{{ paperInfo.unPassNumber }}</span>
          </td>
        </tr>
        <tr>
          <td class="category">总分：
            <span>{{ paperInfo.totalScore }}</span>
          </td>
          <td class="category">通过分数：
            <span>{{ paperInfo.passScore }}</span>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <div class="status">
      <div>
        <p>状态</p>
        <p>{{ status }}</p>
      </div>
    </div>
  </div>
</template>

<script>
const stateMap = {
  Init: '未开始',
  Start: '已开始',
  Completed: '已完成',
  Counted: '已统分',
};

export default {
  name: 'SinglePaperInfo',
  props: {
    paperId: { type: [Number, String], reuqired: true },
    paperInfo: { type: Object, required: true },
  },
  computed: {
    status() {
      return stateMap[this.paperInfo.status];
    },
  },
  methods: {
    /**
     * 点击导出按钮处理函数
     */
    async exportBtnClickHandler() {
      const paperName = this.paperInfo.name;
      const params = `paperId=${this.paperId}&name=${paperName}`;

      await this.$http.examcenter.paperDetailExport(
        { name: paperName }, params,
      );
    },
  },
};
</script>

<style lang="less" scoped>
.paper-info {
  display: flex;
  justify-content: flex-start;
  width: 100%;

  > table {
    flex: 0 0 85%;
    width: 85%;

    > tbody {
      width: 100%;

      > tr {
        width: 100%;
        height: 42px;
        border-bottom: 1px solid #ddd;

        > td {
          width: calc(100% / 3);
          vertical-align: middle;
          font-size: 12px;

          &.category {
            font-weight: bold;

            > span {
              font-weight: normal;
            }

            > a {
              margin-right: 16px;

              &:last-of-type {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }

  > .status {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin: 0 20px;

    > div {
      > p:first-of-type {
        margin-bottom: 10px;
        text-align: right;
      }

      > p:last-of-type {
        font-size: 18px;
      }
    }
  }
}
</style>
